import API from './API.ts'

export default {
  //
  // GET
  //
  getConsumptionPage ({ bookingId, page = 1 }) {
    return API.httpClient.get('tally/consumption', {
      params: {
        booking_id: bookingId,
        page
      }
    })
  },
  getTallyCharges ({ bookingId }) {
    return API.httpClient.get('tally/charges', {
      params: {
        booking_id: bookingId
      }
    })
  },
  fetchCards () {
    return API.httpClient.get('tally/activecards')
  },
  getAccessControlResources () {
    return API.httpClient.get('tally/access-control/resources')
  },
  getTallykeySettings () {
    return API.httpClient.get('tally/settings')
  },

  //
  // POST
  //
  createProvision ({ bookingId }) {
    return API.httpClient.post('tally/provision', {
      booking_id: bookingId
    })
  },
  reprovision ({ bookingId }) {
    return API.httpClient.post('tally/reprovision', {
      booking_id: bookingId
    })
  },
  addCard ({ bookingId, cardUid }) {
    return API.httpClient.post('tally/addcard', {
      booking_id: bookingId,
      card_uid: cardUid
    })
  },
  removeCard ({ bookingId, cardUid }) {
    return API.httpClient.post('tally/removecard', {
      booking_id: bookingId,
      card_uid: cardUid
    })
  },
  regeneratePincode (bookingId) {
    return API.httpClient.post('tally/regenerate-pincode', {
      booking_id: bookingId
    })
  },
  updateAccessControlResource ({ tallyResourceId, action }) {
    return API.httpClient.post('tally/access-control/update', {
      tally_resource_id: tallyResourceId,
      action
    })
  },
  savePincodeDescription ({ pincodeDescription }) {
    return API.httpClient.post('tally/settings/update-pincode-description', {
      pincode_description: pincodeDescription
    })
  }
}
